import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import BannerPromotion from '../../components/bannerPromotion';
import { getPromotions } from '../../slices/promotionSlice';
import LoaderCP from '../../components/loader';

const BannerPromotionContainer = () => {
  const dispatch = useDispatch();
  const { promotions, status } = useSelector((state) => state.promotions);

  useEffect(() => {
    dispatch(getPromotions());
  }, []);

  return (
    <div>
      {status === 'loading' ? <LoaderCP /> : ''}
      {status === 'failed' ? '' : ''}
      {status === 'success' && promotions.length > 0
        ? <BannerPromotion items={promotions} />
        : '' }
    </div>
  );
};

export default BannerPromotionContainer;
